import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecarrentalserviceinkolkata() {



  const cardData =
  {
    keyword: ' Corporate Car Rental Services in Kolkata',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Car Rental Services in Kolkata',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Car Rental Services in Kolkata, catering to the transportation needs of IT parks, business centers, industrial hubs, and corporate offices across the city. Our fleet of executive sedans, SUVs, and premium vehicles ensures safe, comfortable, and punctual travel for employees, clients, and top-level executives. Whether it is daily office commute, airport transfers, inter-office travel, plant visits, business meetings, or VIP transportation, we deliver smooth and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and well-maintained vehicles, Pune Corporate Cars India Private Limited ensures a premium and dependable corporate travel experience for businesses operating in and around Kolkata.',

    top: 'Top Places to Visit in Kolkata with Pune Corporate Car',

"topPlaces": [
  {
    "title": "Victoria Memorial",
    "description": "Victoria Memorial is one of Kolkata’s most iconic landmarks, built between 1906 and 1921 in honor of Queen Victoria. This grand white marble monument blends Indo-Saracenic and Renaissance architectural styles and is surrounded by lush gardens. The museum inside houses sculptures, manuscripts, colonial-era paintings, and historical exhibits that showcase British India’s legacy. Evening light-and-sound shows narrate the city’s evolution, making it a must-visit destination for history lovers, art enthusiasts, and travelers seeking Kolkata’s cultural essence."
  },
  {
    "title": "Howrah Bridge",
    "description": "The Howrah Bridge, officially named Rabindra Setu, is a masterpiece of engineering and one of the world’s largest cantilever bridges. Opened in 1943, it links Howrah and Kolkata across the Hooghly River and carries thousands of pedestrians and vehicles daily. Walking across the bridge offers a close-up experience of Kolkata’s vibrant daily life, bustling river ghats, and stunning city views. Its illuminated look at night transforms the historic structure into a glowing symbol of Kolkata’s timeless character."
  },
  {
    "title": "Dakshineswar Kali Temple",
    "description": "Dakshineswar Kali Temple, located on the eastern bank of the Hooghly River, is one of Kolkata’s most revered spiritual sites. Built in 1855 by Rani Rashmoni, the temple complex is dedicated to Goddess Kali and features nine spires in traditional Bengal temple architecture. It is closely associated with the saint Sri Ramakrishna Paramahamsa, who practiced and taught spiritual philosophies here. The peaceful riverfront, long colonnades, and devotional atmosphere make this temple an uplifting religious and cultural retreat."
  },
  {
    "title": "Indian Museum",
    "description": "Established in 1814, the Indian Museum in Kolkata is the largest and oldest museum in India, often referred to as the ‘Jadu Ghar.’ It houses an extraordinary collection of ancient sculptures, Egyptian mummies, rare fossils, Mughal paintings, coins, animal specimens, and archaeological treasures. The galleries cover art, anthropology, geology, botany, and history, making it a treasure trove of knowledge. A visit here offers a deep dive into India’s natural and cultural evolution through centuries."
  },
  {
    "title": "Birla Planetarium",
    "description": "Birla Planetarium, inaugurated in 1963, is one of the world’s largest planetariums and a top educational attraction in Kolkata. Designed in classical Buddhist architectural style, it hosts daily shows that explore astronomy, the solar system, cosmic discoveries, and space science using advanced projection technologies. Exhibits and models explain planetary motion and astronomical history, making it an exciting experience for students, space enthusiasts, and families interested in learning about the universe."
  },
  {
    "title": "St. Paul’s Cathedral",
    "description": "St. Paul’s Cathedral, completed in 1847, is a stunning example of Gothic Revival architecture in Kolkata. With towering spires, stained glass windows, intricate carvings, and a serene prayer hall, the cathedral evokes the charm of European religious design. The beautifully landscaped grounds offer a peaceful escape from the city rush, and visitors can explore its long history through memorial plaques, artworks, and ancient church documents. During Christmas, the cathedral becomes a hub of celebration and community gathering."
  },
  {
    "title": "Marble Palace",
    "description": "Marble Palace, built in 1835 by Raja Rajendra Mullick, is a lavish 19th-century mansion known for its marble walls, floors, and neoclassical architecture. The mansion features an impressive private collection of Victorian statues, Belgian mirrors, chandeliers, antique clocks, and paintings attributed to European masters. The lush courtyard also houses a small aviary that adds to its charm. Visiting Marble Palace offers an enchanting glimpse into the luxurious lifestyle of Kolkata’s aristocratic era."
  },
  {
    "title": "Science City",
    "description": "Science City is one of the largest science museums in India, offering interactive galleries, 3D theaters, a space theatre, robotics displays, and hands-on learning experiences. The ‘Dynamic Hall,’ ‘Evolution of Life’ exhibit, and outdoor science-themed installations make learning fun and engaging for all ages. The facility blends education with entertainment, making it a popular destination for school trips, families, and science lovers.",
  },
  {
    "title": "Eco Tourism Park",
    "description": "Eco Tourism Park in New Town is a sprawling urban green space spread across more than 450 acres, featuring waterbodies, landscaped gardens, nature trails, and adventure activities. Visitors can enjoy cycling, boating, kayaking, ice skating, toy trains, and themed gardens that offer cultural and botanical displays. The tranquil surroundings, lake views, and modern recreational facilities make it a perfect destination for weekend relaxation and outdoor enjoyment."
  },
  {
    "title": "Park Street",
    "description": "Park Street, famously known as ‘The Street That Never Sleeps,’ is Kolkata’s most vibrant urban hotspot. Lined with heritage restaurants, cafes, nightclubs, bookstores, and colonial-era buildings, it has been the city’s social and entertainment center for decades. From iconic eateries like Mocambo and Peter Cat to Christmas light decorations and live music performances, Park Street captures the lively spirit of Kolkata’s modern lifestyle. It is the go-to destination for food lovers, night owls, and cultural explorers."
  }
],


"services": [
  {
    "name": "Kolkata Corporate Car Rental",
    "description": "Kolkata Corporate Car Rental provides comprehensive corporate car solutions for businesses, offering sedans, SUVs, and luxury vehicles. Designed for employee commutes, executive travel, and corporate operations, it ensures punctual, safe, and comfortable rides with professional chauffeurs."
  },
  {
    "name": "Business Car Hire Kolkata",
    "description": "Business Car Hire Kolkata delivers tailored corporate travel services for meetings, client visits, and inter-office trips. With premium vehicles and experienced drivers, it guarantees reliable, on-demand transportation for executives and staff."
  },
  {
    "name": "Employee Car Rental Kolkata",
    "description": "Employee Car Rental Kolkata provides dedicated vehicles for workforce commuting, featuring scheduled pickups, route optimization, GPS tracking, and professional chauffeurs to ensure safe and timely travel for corporate employees."
  },
  {
    "name": "Company Car Lease Kolkata",
    "description": "Company Car Lease Kolkata offers long-term corporate vehicle leasing solutions, including fleet management, maintenance, driver assignment, and operational support, ideal for companies looking to streamline employee transport."
  },
  {
    "name": "Monthly Corporate Car Rental Kolkata",
    "description": "Monthly Corporate Car Rental Kolkata provides cost-effective, contract-based mobility solutions for regular employee and executive commutes. The service includes dedicated vehicles, GPS tracking, and trained drivers for consistent and reliable transportation."
  },
  {
    "name": "Corporate Fleet Kolkata",
    "description": "Corporate Fleet Kolkata offers end-to-end fleet management services including sedans, SUVs, and shuttle vehicles. It includes driver management, vehicle maintenance, compliance tracking, and scalable transport solutions for businesses in Kolkata."
  },
  {
    "name": "Executive Car Rental Kolkata",
    "description": "Executive Car Rental Kolkata delivers premium corporate travel solutions with luxury and executive vehicles. Designed for senior management, it ensures comfort, punctuality, and a professional travel experience for business trips and client meetings."
  },
  {
    "name": "Sedan Car Rental Kolkata",
    "description": "Sedan Car Rental Kolkata offers high-quality sedans for corporate employee travel, airport pickups, and executive mobility. Vehicles are well-maintained, chauffeur-driven, and equipped with safety and comfort features."
  },
  {
    "name": "SUV Car Rental Kolkata",
    "description": "SUV Car Rental Kolkata provides spacious and durable SUVs for team commutes, executive travel, and outstation business trips. Professional drivers and advanced safety protocols ensure a comfortable and secure ride."
  },
  {
    "name": "Affordable Corporate Car Rental Kolkata",
    "description": "Affordable Corporate Car Rental Kolkata offers budget-friendly yet reliable vehicle solutions for SMEs and mid-sized companies. The service maintains quality, punctuality, and safety while optimizing cost-efficiency for daily employee transport."
  },
  {
    "name": "Luxury Car Rental Kolkata",
    "description": "Luxury Car Rental Kolkata provides high-end premium vehicles for executive travel, client visits, and special corporate events. The service focuses on comfort, professionalism, and elite travel experience."
  },
  {
    "name": "Chauffeur Car Hire Kolkata",
    "description": "Chauffeur Car Hire Kolkata offers fully managed driver services for corporate vehicles, ensuring trained, professional, and reliable chauffeurs for employee, executive, and VIP transportation across Kolkata."
  },
  {
    "name": "Airport Corporate Car Rental Kolkata",
    "description": "Airport Corporate Car Rental Kolkata delivers specialized airport transfer services for employees and executives, featuring punctual pickups, comfortable sedans and SUVs, and professional drivers for hassle-free airport commutes."
  },
  {
    "name": "Outstation Corporate Car Rental Kolkata",
    "description": "Outstation Corporate Car Rental Kolkata provides long-distance corporate travel services including interstate trips, client visits, factory tours, and executive road travel. Vehicles are chauffeur-driven with GPS tracking for safe and comfortable journeys."
  },
  {
    "name": "Staff Transportation Car Rental Kolkata",
    "description": "Staff Transportation Car Rental Kolkata offers structured workforce commute solutions with scheduled routes, professional drivers, and managed fleets, ensuring safe, reliable, and timely transport for corporate employees."
  }
],

"tableData": [
  ["Kolkata Corporate Car Rental", "Business Car Hire Kolkata"],
  ["Employee Car Rental Kolkata", "Company Car Lease Kolkata"],
  ["Monthly Corporate Car Rental Kolkata", "Corporate Fleet Kolkata"],
  ["Executive Car Rental Kolkata", "Sedan Car Rental Kolkata"],
  ["SUV Car Rental Kolkata", "Affordable Corporate Car Rental Kolkata"],
  ["Luxury Car Rental Kolkata", "Chauffeur Car Hire Kolkata"],
  ["Airport Corporate Car Rental Kolkata", "Outstation Corporate Car Rental Kolkata"],
  ["Staff Transportation Car Rental Kolkata", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Corporate Car Rental Services in Kolkata",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides dependable corporate car rental services in Kolkata, ensuring smooth and efficient transportation for employees and business executives across the city."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We guarantee punctual pickups and drop-offs across Kolkata’s corporate offices, industrial zones, and business districts, helping employees reach work and meetings on time."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs provide safe, courteous, and disciplined travel, ensuring a secure and comfortable commute for corporate clients."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and maintained for reliable and comfortable corporate travel in Kolkata."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We offer flexible and tailored corporate car rental plans designed to meet the commuting needs of companies and employees in Kolkata."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for bookings, emergencies, and route adjustments, ensuring uninterrupted corporate transportation."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are sanitized regularly and equipped with modern safety features, offering secure and comfortable rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is managed effortlessly through our streamlined booking process and reliable coordination, making employee transport hassle-free."
  }
]













  }

  
const faqData = [
  {
    question: 'Do you provide corporate car rental services in Kolkata?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers professional and reliable corporate car rental services for companies, offices, and events in Kolkata.',
  },
  {
    question: 'What types of corporate transportation services do you offer in Kolkata?',
    answer: 'We provide employee transportation, airport transfers, corporate pickups and drops, outstation travel, and complete fleet management for businesses.',
  },
  {
    question: 'Do you support daily commute services for corporate employees in Kolkata?',
    answer: 'Yes, we offer structured daily commute solutions with optimized routes, punctual pickups, and multi-shift support for employees.',
  },
  {
    question: 'How can companies book corporate car rental services in Kolkata?',
    answer: 'Bookings can be made through our website, mobile app, or by contacting our 24×7 dedicated corporate support team.',
  },
  {
    question: 'Which vehicles are available for corporate rentals in Kolkata?',
    answer: 'We provide hatchbacks, sedans, SUVs, Innova Crysta, luxury cars, tempo travellers, and electric cabs based on corporate needs.',
  },
  {
    question: 'Do you offer long-term corporate car rental contracts in Kolkata?',
    answer: 'Yes, we provide monthly, quarterly, and annual rental contracts with flexible pricing and complete fleet management solutions.',
  },
  {
    question: 'Are your vehicles equipped with GPS and safety features?',
    answer: 'All our vehicles are GPS-enabled, regularly sanitized, and driven by trained and background-verified chauffeurs to ensure safety.',
  },
  {
    question: 'Do you provide services for night shifts and rotational shifts in Kolkata?',
    answer: 'Absolutely. We offer transportation for night shifts, early morning shifts, rotational schedules, and weekend operations.',
  },
  {
    question: 'What payment options are available for corporate car rental services?',
    answer: 'We accept UPI, bank transfers, credit/debit cards, digital wallets, and also provide consolidated monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Arindam Sen',
    feedback: 'Reliable corporate car rental service in Kolkata. Timely pickups, professional drivers, and clean vehicles every day.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Rituparna Das',
    feedback: 'Excellent service for our corporate travel needs. Flexible plans and well-maintained fleet make commuting smooth.',
    rating: 5,
  },
];












































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Car Rental Services in Kolkata",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-car-kolkata.jpg", // replace with actual image URL
  "description":
    "Pune Corporate Cars India Private Limited provides premium corporate car rental services in Kolkata, including business car hire, employee car rental, company car lease, monthly corporate rentals, executive car services, sedan & SUV rentals, luxury car hire, chauffeur-driven cars, airport corporate transfers, outstation trips, and complete corporate fleet management.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-car-rental-kolkata"
  }
};





  return (
    <div>
<Helmet>
  <title>Corporate Car Rental Services in Kolkata | Employee & Business Car Hire</title>

  <meta
    name="description"
    content="Premium corporate car rental services in Kolkata including business car hire, employee car rental, company car lease, monthly corporate rentals, executive car services, sedan & SUV rentals, luxury car hire, chauffeur-driven cars, airport corporate transfers, outstation trips, and corporate fleet solutions."
  />

  <meta
    name="keywords"
    content="Kolkata Corporate Car Rental, Business Car Hire Kolkata, Employee Car Rental Kolkata, Company Car Lease Kolkata, Monthly Corporate Car Rental Kolkata, Corporate Fleet Kolkata, Executive Car Rental Kolkata, Sedan Car Rental Kolkata, SUV Car Rental Kolkata, Affordable Corporate Car Rental Kolkata, Luxury Car Rental Kolkata, Chauffeur Car Hire Kolkata, Airport Corporate Car Rental Kolkata, Outstation Corporate Car Rental Kolkata, Staff Transportation Car Rental Kolkata"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/90.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecarrentalserviceinkolkata;